import React, { useEffect, useState } from 'react';
import { Button } from '../../styles/common/Button.styled';
import { ConsoleInput, ConsoleLabel } from '../../styles/common/input.styled';
import KeypadSelector from '../common/KeypadSelector';
import { IvrSettingsFields, IvrSettingsPanel } from './IvrSettingsPanel';

interface Props {
  edgeId: string;
  sourceHandle: string | null | undefined;
  ingressPath?: string;
  disabledKeys: string[];
  onUpdate: (key: string, ingressPath?: string) => boolean;
  onDirtyChange: (dirty: boolean) => void;
  onClose: () => void;
  onCancel: () => void;
}

const IvrIngressPathSettings = ({ edgeId, sourceHandle, ingressPath, disabledKeys, onUpdate, onDirtyChange, onClose, onCancel }: Props) => {
  const [initial] = useState(() => ({ key: sourceHandle || '', path: ingressPath || '' }));
  const [draft, setDraft] = useState(initial);

  useEffect(() => { onDirtyChange(JSON.stringify(initial) !== JSON.stringify(draft)); }, [initial, draft, onDirtyChange]);
  const apply = () => {
    if (!draft.key) return;
    onUpdate(draft.key, draft.path.trim() || undefined);
  };

  return <IvrSettingsPanel aria-label="선택 ARS 분기 설정" data-edge-id={edgeId}>
    <header><h2>ARS 분기 설정</h2><Button $variant="ghost" aria-label="ARS 분기 설정 닫기" onClick={onClose}>×</Button></header>
    <IvrSettingsFields>
      <small>키패드와 유입경로를 함께 설정합니다.</small>
      <div><ConsoleLabel>키패드</ConsoleLabel><KeypadSelector value={draft.key || null} onChange={key => setDraft(current => ({ ...current, key }))} disabledKeys={disabledKeys} /></div>
      <ConsoleLabel htmlFor="ingress-path-panel">유입경로<ConsoleInput id="ingress-path-panel" value={draft.path} maxLength={10} onChange={event => setDraft(current => ({ ...current, path: event.target.value }))} placeholder="선택 입력 · 최대 10자" /></ConsoleLabel>
    </IvrSettingsFields>
    <footer><Button $variant="secondary" onClick={onCancel}>취소</Button><Button $variant="primary" onClick={apply} disabled={!draft.key}>분기 적용</Button></footer>
  </IvrSettingsPanel>;
};

export default IvrIngressPathSettings;
